var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import find from 'lodash/find';
import { useTranslation } from 'react-i18next';
import { getGtmTagValue } from '../../../utils/gtmEvents';
import { mapGTMCategory } from '../../../utils/sitecoreFields';
import { variant1, variant2, variant3 } from './constants';
// eslint-disable-next-line import/prefer-default-export
export var useConfiguration = function (variant) {
    var t = useTranslation().t;
    var buttonWrapperStyling = {
        display: ['block', 'flex'],
        textAlign: 'center',
        justifyContent: 'center',
        marginTop: 'l',
        mx: 'auto',
        maxWidth: '220px',
    };
    var variantConfig = {
        // autos
        variant1: {
            colorSwatchAlignment: ['left', 'left', 'left'],
            ctaButtons: ['Buildable', 'TestDrivable', 'Comparable'],
            ctaLabel: t('Pages.Models.Exploration.selectTrimLabel'),
            exteriorColorLabel: t('Pages.Models.Exploration.exteriorColoursLabel'),
            fontLineHeight: ['22px', '22px', '26px'],
            hasColorsAccordion: true,
            hasInteriorColors: true,
            labelFontSize: '12px',
            selectedTransmissionKeyPath: 'detIdentifier',
            selectedTransmissionKeyUseBapUrl: false,
            selectTrimButton: true,
            selectTrimDropDownLabel: t('Pages.Models.Exploration.selectTrimDropdownLabel'),
            showMobilePayment: false,
            showFeesLabel: true,
            showPaymentDetails: false,
            showPaymentInfoTooltip: true,
            showTransmissionToggle: true,
            showCompareTrimsLabel: true,
            showSellingPriceDisclaimer: false,
            selectHeading: t('Pages.Models.Exploration.selectTrimHeading'),
            transmissionLabel: t('Pages.Models.Exploration.transmissionLabel'),
            valueFontSize: '16px',
            showRebateDisclaimerIndicator: false,
            priceStyles: {
                priceStyles: {
                    title: {
                        size: 'extraSmall',
                    },
                },
            },
            zIndexWorkaroundClassName: 'acura-z-index-workaround honda-z-index-workaround',
            buttonWrapperStyling: __assign({}, buttonWrapperStyling),
            sellingPriceTooltipDiscalimerLabel: t('Shared.Common.sellingPriceTooltipLabel'),
        },
        // PSP
        variant2: {
            colorSwatchAlignment: ['center', 'center', 'left'],
            ctaButtons: ['PriceFinance', 'AddToCompare', 'FindDealer'],
            ctaLabel: t('Pages.Models.Exploration.viewModelDetailsButton'),
            exteriorColorLabel: t('Pages.Models.Exploration.availableColoursLabel'),
            fontLineHeight: '22px',
            hasColorsAccordion: false,
            hasInteriorColors: false,
            labelFontSize: '10px',
            selectedTransmissionKeyPath: 'defaultTransmission.detIdentifier.value',
            selectedTransmissionKeyUseBapUrl: true,
            selectTrimButton: true,
            selectTrimDropDownLabel: t('Pages.Models.Exploration.selectModelLabel'),
            showMobilePayment: true,
            showFeesLabel: false,
            showModelYear: false,
            showPaymentDetails: true,
            showPaymentInfoTooltip: false,
            showDisclaimerModal: true,
            showSellingPriceDisclaimer: true,
            showTransmissionToggle: false,
            showCompareTrimsLabel: false,
            showAccessoryCreditOffer: true,
            selectHeading: t('Pages.Models.Exploration.selectModelHeading'),
            transmissionLabel: t('Pages.Models.Exploration.modelDetailsTrimLabel'),
            valueFontSize: ['16px', '16px', '18px'],
            showRebateDisclaimerIndicator: false,
            priceStyles: {
                priceStyles: {
                    title: {
                        size: 'extraSmall',
                    },
                    disclaimer: { size: 'extraSmall', styles: { maxWidth: ['220px', '220px', '100%'] } },
                },
                saveStyles: {
                    container: {
                        marginX: ['auto', 'auto', 0],
                    },
                },
            },
            zIndexWorkaroundClassName: 'psp-z-index-workaround',
            showAddToCompareButton: true,
            buttonWrapperStyling: __assign({}, buttonWrapperStyling),
            sellingPriceTooltipDiscalimerLabel: t('Shared.Common.sellingPriceTooltipLabel'),
        },
    };
    var style;
    switch (variant) {
        // autos
        case variant1:
            style = variantConfig.variant1;
            break;
        // PE
        case variant3:
            style = __assign(__assign({}, variantConfig.variant1), { showCompareTrimsLabel: false, ctaLabel: t('Shared.Common.viewDetailsButton'), ctaButtons: ['BuyNow', 'AddToCompare', 'FindDealer'], showAccessoryCreditOffer: true, showModelCode: true, showModelHighlights: true, showFeesLabel: false, hasInteriorColors: false, selectTrimDropDownLabel: t('Pages.Models.Exploration.selectModelLabel'), priceStyles: {
                    priceStyles: {
                        title: {
                            size: 'extraSmall',
                        },
                    },
                    saveStyles: {
                        container: {
                            marginX: ['auto', 'auto', 0],
                        },
                    },
                }, showRebateDisclaimerIndicator: true, sellingPriceTooltipDiscalimerLabel: t('Shared.Common.sellingPriceTooltipText') });
            break;
        // psp
        case variant2:
        default:
            style = variantConfig.variant2;
            break;
    }
    return style;
};
export var getGtmCategoryProp = function (fields, variant) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    switch (variant) {
        case variant2:
            return (_f = (_e = (_d = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.modelYear) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.category) === null || _e === void 0 ? void 0 : _e.categoryName) === null || _f === void 0 ? void 0 : _f.value;
        case variant3:
            return (_l = (_k = (_j = (_h = (_g = fields === null || fields === void 0 ? void 0 : fields.data) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.subCategory) === null || _j === void 0 ? void 0 : _j.fields) === null || _k === void 0 ? void 0 : _k.category) === null || _l === void 0 ? void 0 : _l.name;
        default:
            return mapGTMCategory((_o = (_m = fields === null || fields === void 0 ? void 0 : fields.data) === null || _m === void 0 ? void 0 : _m.value) === null || _o === void 0 ? void 0 : _o.gtmCategory);
    }
};
export var getTrimCardGtm = function (_a) {
    var variant = _a.variant, trim = _a.trim, componentName = _a.componentName, vehicleType = _a.vehicleType, gtmCategory = _a.gtmCategory, gtmModelName = _a.gtmModelName, gtmTitle = _a.gtmTitle, gtmInteractionType = _a.gtmInteractionType;
    var common = {
        'data-gtm-component-type': getGtmTagValue(componentName),
    };
    switch (variant) {
        case variant2:
            return Object.freeze({
                'data-gtm-interaction-type': getGtmTagValue(gtmInteractionType || 'cta: explore'),
                'data-gtm-title': getGtmTagValue(gtmTitle),
                'data-gtm-body-style': getGtmTagValue(gtmCategory),
                'data-gtm-category': getGtmTagValue(vehicleType),
                'data-gtm-model': getGtmTagValue(gtmModelName || (trim === null || trim === void 0 ? void 0 : trim.gtmModelName)),
            });
        default:
            return Object.freeze(__assign(__assign({}, common), { 'data-gtm-interaction-type': getGtmTagValue(gtmInteractionType || 'trim selection'), 'data-gtm-title': getGtmTagValue(gtmTitle || 'trim selector'), 'data-gtm-category': getGtmTagValue(gtmCategory), 'data-gtm-body-style': getGtmTagValue(vehicleType), 'data-gtm-model': getGtmTagValue(gtmModelName || (trim === null || trim === void 0 ? void 0 : trim.gtmModelName)) }));
    }
};
export var getFeaturesItem = function (fields, variant, selectedTrimKey) {
    var _a, _b, _c, _d;
    var featuresItem;
    switch (variant) {
        // PE
        case variant3:
            featuresItem = find((_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.modelFeatures, function (trimFeature) { var _a; return (_a = trimFeature === null || trimFeature === void 0 ? void 0 : trimFeature.models) === null || _a === void 0 ? void 0 : _a.fields.find(function (model) { var _a; return ((_a = model.detKey) === null || _a === void 0 ? void 0 : _a.value) === selectedTrimKey; }); });
            break;
        default:
            featuresItem = find((_d = (_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.trimFeatures, function (trimFeature) { var _a; return (_a = trimFeature === null || trimFeature === void 0 ? void 0 : trimFeature.trims) === null || _a === void 0 ? void 0 : _a.fields.find(function (trim) { var _a; return ((_a = trim.detKey) === null || _a === void 0 ? void 0 : _a.value) === selectedTrimKey; }); });
            break;
    }
    return featuresItem;
};
